<template>
    <div class="tabs">
        <div :class="getClassName(item.value)" v-for="item in tabArr" :key="item.value" @click="onClickTab(item.value)">
            {{ item.label }}
        </div>
        <div class="bg left" :class="getMoveLeft()"></div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
type Props = {
    tabArr: Array<{ label: string; value: number }>;
    width?: number;
};
const props = withDefaults(defineProps<Props>(), {
    tabArr: () => [] as Array<{ label: string; value: number }>,
    width: 197
});

const activeName = defineModel<number>("activeName", { default: 0 });
const tabMoveLeft = ref("4px");
const getClassName = (index: number) => {
    return activeName.value === index ? "tabs--item active" : "tabs--item";
};

const tabWidth = ref("");
const setTabWidth = () => {
    const width = props.width * props.tabArr.length;
    const padding = 8;
    tabWidth.value = `${width + padding}px`;
};

const getMoveLeft = () => {
    const index = props.tabArr.findIndex(item => item.value === activeName.value);
    const paddingLeft = 4;
    tabMoveLeft.value = `${props.width * index + paddingLeft}px`;
};

const onClickTab = (num: number) => {
    activeName.value = num;
};
setTabWidth();
</script>

<style scoped lang="scss">
.tabs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f8f8f8;
    height: 48px;
    padding: 4px;
    box-sizing: border-box;
    border-radius: 6px;
    width: v-bind(tabWidth);
    position: relative;

    &--item {
        width: 197px;
        height: 40px;
        font-weight: 400;
        cursor: pointer;
        line-height: 40px;
        text-align: center;
        color: #666666;
        font-size: 16px;
        position: relative;
        z-index: 1;
        transition: all 0.3s;
        &.active {
            background: #ffffff;
            flex-shrink: 0;
            border-radius: 6px;
            color: #2143fc;
            font-size: 16px;
        }
    }

    .bg {
        width: 197px;
        height: 40px;
        background: var(--el-color-theme-light-5);
        position: absolute;
        border-radius: 6px;
        transition: all 0.3s;
    }

    .left {
        left: v-bind(tabMoveLeft);
    }
}
</style>
